import React from 'react';
import { Svg, ISvg } from '../Svg';

export const LinkedIn: React.FC<ISvg> = (props) => (
  <Svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M7.63206 16.9997V7.55356H4.20217V16.9997H7.63242H7.63206ZM5.91783 6.26408C7.11365 6.26408 7.85813 5.53873 7.85813 4.63224C7.83575 3.70511 7.11365 3 5.94057 3C4.76668 3 4 3.70511 4 4.63216C4 5.53864 4.74421 6.26399 5.89536 6.26399H5.91756L5.91783 6.26408ZM9.53055 16.9997H12.9602V11.7251C12.9602 11.4432 12.9826 11.1605 13.0732 10.9591C13.321 10.3948 13.8853 9.81067 14.8331 9.81067C16.0738 9.81067 16.5705 10.6768 16.5705 11.9468V16.9997H20V11.5836C20 8.68224 18.3082 7.3321 16.0516 7.3321C14.2016 7.3321 13.389 8.27867 12.9376 8.92337H12.9604V7.55389H9.53073C9.57549 8.44005 9.53046 17 9.53046 17L9.53055 16.9997Z"
      fill="#0077B5"
    />
  </Svg>
);
